import { render, staticRenderFns } from "./BottomNavMenu.vue?vue&type=template&id=2dc5400c"
import script from "./BottomNavMenu.vue?vue&type=script&lang=js"
export * from "./BottomNavMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports